import { IPresentationException } from '@/common/interface';

export const parseError = (error: any) => {
  // Error 😨
  if (error) {
    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
     */
    return `${error.status || 'Error'}: - ${
      error.data?.error_description || error.data || error.message || error
    }`;
  } else {
    // Something happened in setting up the request and triggered an Error
    return 'Unexpected Error';
  }
};

export const toPresentationException = (error: any): IPresentationException => {
  return { description: 'Error', message: parseError(error), status: error?.status || 0 };
};
